import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'antd'
import { Redirect } from 'react-router-dom'

import * as actions from './LoginPageActions'
import logo from '../../public/assets/images/ic_new_logo.jpg'
import './LoginPage.scss'

export class LoginPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            username: '',
            password: ''
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    handleFormChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit(e) {
        e.preventDefault()

        const { username, password } = this.state
        const { login } = this.props

        login({ username, password })
    }

    render() {
        const { username, password } = this.state
        const { isLogin, errMsg } = this.props

        if (isLogin === true)
            return <Redirect to="/workdesk"/>
        else
            return (
                <div className="LoginPage">
                    <div className="login-container">
                        <img src={logo} alt="Cheer System Logo"/>
                        <form className="login-box" onSubmit={this.handleSubmit.bind(this)}>
                            <p className="error-message">{errMsg}</p>
                            <input type="text" placeholder="Username" name="username" value={username} onChange={this.handleFormChange}/>
                            <input type="password" placeholder="Password" name="password" value={password} onChange={this.handleFormChange}/>
                            <Button type="primary" htmlType="submit" size="large">Login</Button>
                        </form>
                    </div>
                </div>
            )
    }
}

const mapStateToProps = (state) => {
    return {
        isLogin: state.auth.isLogin,
        errMsg: state.auth.errMsg
    }
}

export default connect(mapStateToProps, actions)(LoginPage)



// WEBPACK FOOTER //
// ./src/LoginPage/LoginPage.js